/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HeatLoadByBuildingHullRequestPost } from '../../models/heat-load-by-building-hull-request-post';
import { HeatLoadByBuildingHullResponse } from '../../models/heat-load-by-building-hull-response';

export interface CalculationsControllerBuildingHull$Params {
      body: HeatLoadByBuildingHullRequestPost
}

export function calculationsControllerBuildingHull(http: HttpClient, rootUrl: string, params: CalculationsControllerBuildingHull$Params, context?: HttpContext): Observable<StrictHttpResponse<HeatLoadByBuildingHullResponse>> {
  const rb = new RequestBuilder(rootUrl, calculationsControllerBuildingHull.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<HeatLoadByBuildingHullResponse>;
    })
  );
}

calculationsControllerBuildingHull.PATH = '/planning-projects/v1/calculations/heat-load/building-hull';
